import { FC, PropsWithChildren } from 'react';
import { PiiRoles, PiiTypes } from '../../analytics/dataMasking';

interface MaskableStudent {
  publicUserId: string | null | undefined;
}

interface Props extends PropsWithChildren {
  student: MaskableStudent;
  type: PiiTypes;
  className?: string;
}

export const MaskedStudentData: FC<Props> = ({ student, type, className, children }) => {
  return (
    <span
      className={className}
      data-pii-role={PiiRoles.Student}
      data-pii-type={type}
      data-pii-public-user-id={student?.publicUserId}
    >
      {children}
    </span>
  );
};
